export const timeframes = ["1d", "4h", "1h", "15m", "5m", "1m"];
export const tradingpairs = [
  "BTCUSDT",
  "ETHUSDT",
  "BCHUSDT",
  "XRPUSDT",
  "EOSUSDT",
  "LTCUSDT",
  "TRXUSDT",
  "ETCUSDT",
  "LINKUSDT",
  "XLMUSDT",
  "ADAUSDT",
  "XMRUSDT",
  "DASHUSDT",
  "ZECUSDT",
  "XTZUSDT",
  "BNBUSDT",
  "ATOMUSDT",
  "ONTUSDT",
  "IOTAUSDT",
  "BATUSDT",
  "VETUSDT",
  "NEOUSDT",
  "QTUMUSDT",
  "IOSTUSDT",
  "THETAUSDT",
  "ALGOUSDT",
  "ZILUSDT",
  "KNCUSDT",
  "ZRXUSDT",
  "COMPUSDT",
  "OMGUSDT",
  "DOGEUSDT",
  "SXPUSDT",
  "KAVAUSDT",
  "BANDUSDT",
  "RLCUSDT",
  "WAVESUSDT",
  "MKRUSDT",
  "SNXUSDT",
  "DOTUSDT",
  "DEFIUSDT",
  "YFIUSDT",
  "BALUSDT",
  "CRVUSDT",
  "TRBUSDT",
  "RUNEUSDT",
  "SUSHIUSDT",
  "EGLDUSDT",
  "SOLUSDT",
  "ICXUSDT",
  "STORJUSDT",
  "BLZUSDT",
  "UNIUSDT",
  "AVAXUSDT",
  "FTMUSDT",
  "ENJUSDT",
  "FLMUSDT",
  "RENUSDT",
  "KSMUSDT",
  "NEARUSDT",
  "AAVEUSDT",
  "FILUSDT",
  "RSRUSDT",
  "LRCUSDT",
  "MATICUSDT",
  "OCEANUSDT",
  "BELUSDT",
  "CTKUSDT",
  "AXSUSDT",
  "ALPHAUSDT",
  "ZENUSDT",
  "SKLUSDT",
  "GRTUSDT",
  "1INCHUSDT",
  "CHZUSDT",
  "SANDUSDT",
  "ANKRUSDT",
  "LITUSDT",
  "UNFIUSDT",
  "REEFUSDT",
  "RVNUSDT",
  "SFPUSDT",
  "XEMUSDT",
  "COTIUSDT",
  "CHRUSDT",
  "MANAUSDT",
  "ALICEUSDT",
  "HBARUSDT",
  "ONEUSDT",
  "LINAUSDT",
  "STMXUSDT",
  "DENTUSDT",
  "CELRUSDT",
  "HOTUSDT",
  "MTLUSDT",
  "OGNUSDT",
  "NKNUSDT",
  "DGBUSDT",
  "SHIBUSDT",
  "BAKEUSDT",
  "GTCUSDT",
  "BTCDOMUSDT",
  "IOTXUSDT",
  "AUDIOUSDT",
  "C98USDT",
  "MASKUSDT",
  "ATAUSDT",
  "DYDXUSDT",
  "XECUSDT",
  "GALAUSDT",
  "CELOUSDT",
  "ARUSDT",
  "KLAYUSDT",
  "ARPAUSDT",
  "CTSIUSDT",
  "LPTUSDT",
  "ENSUSDT",
  "PEOPLEUSDT",
  "ANTUSDT",
  "ROSEUSDT",
  "DUSKUSDT",
  "FLOWUSDT",
  "IMXUSDT",
  "API3USDT",
  "GMTUSDT",
  "APEUSDT",
  "WOOUSDT",
  "JASMYUSDT",
  "DARUSDT",
  "GALUSDT",
  "OPUSDT",
  "INJUSDT",
  "STGUSDT",
  "FOOTBALLUSDT",
  "SPELLUSDT",
  "LUNCUSDT",
  "LUNA2USDT",
  "LDOUSDT",
  "CVXUSDT",
  "ICPUSDT",
  "APTUSDT",
  "QNTUSDT",
  "BLUEBIRDUSDT",
  "FETUSDT",
  "FXSUSDT",
  "HOOKUSDT",
  "MAGICUSDT",
  "TUSDT",
  "RNDRUSDT",
  "HIGHUSDT",
  "MINAUSDT",
  "ASTRUSDT",
  "AGIXUSDT",
  "PHBUSDT",
  "GMXUSDT",
  "CFXUSDT",
  "STXUSDT",
  "BNXUSDT",
  "ACHUSDT",
  "SSVUSDT",
  "CKBUSDT",
  "PERPUSDT",
  "TRUUSDT",
  "LQTYUSDT",
  "USDCUSDT",
  "IDUSDT",
  "ARBUSDT",
  "JOEUSDT",
  "TLMUSDT",
  "AMBUSDT",
  "LEVERUSDT",
  "RDNTUSDT",
  "HFTUSDT",
  "XVSUSDT",
  "BLURUSDT",
  "EDUUSDT",
  "IDEXUSDT",
  "SUIUSDT",
  "PEPEUSDT",
  "FLOKIUSDT",
  "UMAUSDT",
  "RADUSDT",
  "KEYUSDT",
  "COMBOUSDT",
  "NMRUSDT",
  "MAVUSDT",
  "MDTUSDT",
  "XVGUSDT",
  "WLDUSDT",
  "PENDLEUSDT",
  "ARKMUSDT",
  "AGLDUSDT",
  "YGGUSDT",
  "DODOXUSDT",
  "BNTUSDT",
  "OXTUSDT",
  "SEIUSDT",
  "CYBERUSDT",
  "HIFIUSDT",
  "ARKUSDT",
  "FRONTUSDT",
  "GLMRUSDT",
  "BICOUSDT",
  "STRAXUSDT",
  "LOOMUSDT",
  "BIGTIMEUSDT",
  "BONDUSDT",
  "ORBSUSDT",
  "STPTUSDT",
  "WAXPUSDT",
  "BSVUSDT",
  "RIFUSDT",
  "POLYXUSDT",
  "GASUSDT",
  "POWRUSDT",
  "SLPUSDT",
  "TIAUSDT",
  "SNTUSDT",
  "CAKEUSDT",
  "MEMEUSDT",
  "TWTUSDT",
  "TOKENUSDT",
  "ORDIUSDT",
  "STEEMUSDT",
  "BADGERUSDT",
  "ILVUSDT",
  "NTRNUSDT",
  "MBLUSDT",
  "KASUSDT",
  "BEAMXUSDT",
  "BONKUSDT",
  "PYTHUSDT",
  "SUPERUSDT",
  "USTCUSDT",
  "ONGUSDT",
  "ETHWUSDT",
  "JTOUSDT",
  "1000SATSUSDT",
  "AUCTIONUSDT",
  "RATSUSDT",
  "ACEUSDT",
  "MOVRUSDT",
  "NFPUSDT",
];
